import { RefinedDataItem } from "@/lib/useQuery/useGetExportData";

export function countErrorsInRowForFields(
    row: RefinedDataItem,
    fields: string[] = [],
): number {
    fields = [...fields, 'Values']
    return fields.reduce((acc, field) => {
        const error = row[field]?.isValid === false && row[field]?.errors.length > 0;
        if (error) {
            acc++;
        }
        return acc;
    }, 0);
}